import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DbContextService } from '../../../services/db-context.service';
import { Helper } from '../../common/helper';
import { ShipCrewData } from '../model/ship-crew-data';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ShipCrewService {

  constructor(private http: HttpClient, private dbxService: DbContextService) { }

  getShipCrewList() {

    return this.http.post(Helper.API_URL() + '/api/maintenance/GetShipCrewListByShipId', {});
  }

  getShipCrewListIntoIndexDb() {
    this.getShipCrewList().subscribe((res: any) => {
      if (res.errorMessage.length <= 0) {
        this.saveShipCrewIndxDb(res.entity.list);
      }
    })
  }

  // Index DB -------------------------------------------------------------------

  getShipCrewIndxDb(transType: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let crewList: ShipCrewData[] = [];
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblShipCrew', 'readwrite');
        let store = tx.objectStore('OWS_tblShipCrew');
        store.getAll().then(
          (res: ShipCrewData[]) => {
            switch (transType) {
              case "All":
                crewList = res;
                break;
              case "Pending":
                res.forEach((crew: ShipCrewData) => {
                  if (isNaN(Number(crew.shipCrewID.toString()))) {
                    crewList.push(crew);
                  }
                });
                break;
            }
            resolve(crewList);
          })
      });
    });
    return promise;
  }

  saveShipCrewIndxDb(shipCrewList: ShipCrewData[]) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblShipCrew', 'readwrite');
      let store = tx.objectStore('OWS_tblShipCrew');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      //clear crew with valid id or prev crews pulled from ifsobs
      store.getAll().then(
        (res: ShipCrewData[]) => {
          res.forEach((crew: ShipCrewData) => {
            //get only crew with valid id, not new crew that are not yet pushed to ifsobs
            if (!isNaN(Number(crew.shipCrewID.toString()))) {
              store.delete(crew.shipCrewID);
            }
          });

          //add recently pulled crews from ifsobs
          shipCrewList.forEach((crew: ShipCrewData) => {
            try {
              let req = store.add(crew);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          });
        });
    });
  }

  deleteShipCrewIndxDb(shipCrewID: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblShipCrew', 'readwrite');
        let store = tx.objectStore('OWS_tblShipCrew');
        store.get(shipCrewID).then((r: any) => {
          store.delete(shipCrewID).then(() => {
            resolve(true);
          });
        })
      })
    })
    return promise;

  }

  getCrewAttestationCertificateReport(data: any) {
    return this.http.post(Helper.API_URL() + '/api/CrewMaintenance/GenIVIAttestationCertificate', data, { responseType: 'arraybuffer' as 'json' });
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
